import axios from 'axios'
import { serverAddress } from './config'

export async function getSocialPosts(request) {
  console.log('request>>>>>>>>>', request)
  const url = `${serverAddress}/api/social/list?approved=${request.approved}&page=${request.page}`
  return axios
    .get(url)
    .then((response) => {
      if (response.status === 200) {
        return response
      }
      return false
    })
    .catch((error) => {
      return error
    })
}

export async function approveSocialPost(request) {
  const body = request.body
  const url = `${serverAddress}/api/social/approve`
  return axios
    .post(url, body)
    .then((response) => {
      if (response.status === 200) {
        return response
      }
      return false
    })
    .catch((error) => {
      return error
    })
}
